import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'

import { cn } from '../../lib/utils'

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, max, ...props }, ref) => {
  const normalizedValue = (((value ?? 0) - 0) / ((max ?? 0) - 0)) * 100

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'relative h-1 w-full overflow-hidden rounded-full bg-ui',
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          !normalizedValue ? 'bg-ui' : 'bg-secondary',
          'h-1 w-full flex-1 transition-all rounded-full',
        )}
        style={{ transform: `translateX(-${100 - normalizedValue}%)` }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
